import { isNullOrUndefined } from '@/utils/functions'
import axiosFlow from '../axios/axiosFlow'

export default class TicketAgendamentoTipoService {
  static async get(itensPerPage, ativo) {
    const params = new URLSearchParams()

    params.append('ItensPerPage', itensPerPage)

    if (!isNullOrUndefined(ativo)) {
      params.append('Ativo', ativo)
    }

    return axiosFlow.get(`tickets/agendamentos/tipos?${params}`).then(res => res.data.data.items)
  }

  static async getTipoAgendamentoById(tipoDeAgendamentoId) {
    return axiosFlow.get(`tickets/agendamentos/tipos/${tipoDeAgendamentoId}`).then(res => res.data.data)
  }

  static async criarTipoDeAgendamento(body) {
    return axiosFlow.post('tickets/agendamentos/tipos', body)
  }

  static async atualizarTipoDeAgendamento(tipoDeAgendamentoId, body) {
    return axiosFlow.put(`tickets/agendamentos/tipos/${tipoDeAgendamentoId}`, body)
  }

  static async ativarOuInativarTipoDeAgendamento(tipoDeAgendamentoId, body) {
    return axiosFlow.put(`tickets/agendamentos/tipos/${tipoDeAgendamentoId}/ativos`, body)
  }
}
